<app-navbar-control></app-navbar-control>

@if (!isLoaded) {
<div class="progress">
  <div class="progress-bar indeterminate"></div>
</div>
}

@if (blog) {

<section class="blog-detail">

  <div class="container">

    <div class="blog-header">

      <a class="back-btn" [routerLink]="['../']">

        <fa-icon [icon]="faChevronLeft"></fa-icon>

        <span>
          Back to Articles
        </span>

      </a>


      <h1 class="blog-title">
        {{ blog.title }}
      </h1>

      <p class="blog-subtitle">
        Insights, strategies, and practical guidance to help
        businesses streamline scheduling and improve operations.
      </p>

    </div>

    @if (blog.imageUrl) {

    <div class="blog-hero-image">

      <img [src]="blog.imageUrl" alt="{{ blog.title }}" class="img-fluid">

    </div>

    }

    <div class="blog-content">

      <div [innerHTML]="safeContent"></div>

    </div>

  </div>

</section>

}